// document.addEventListener("DOMContentLoaded", function () {
//   if (!window.location.pathname.includes("/pages/sales-page")) {
//     console.log("Virtual scroll tracking skipped — not sales page");
//     return;
//   }

//   console.log("Virtual scroll tracking active on:", window.location.pathname);

//   const baseTitle = document.title.replace(/\s+/g, '-');

//   const sections = [
//     { id: "shopify-section-template--25803843436917__sp_header_jUzLtP", url: "?section=header", name: "header" },
//     { id: "shopify-section-template--25803843436917__sp_banner_block_kwQNWH", url: "?section=banner-block", name: "banner-block" },
//     { id: "shopify-section-template--25803843436917__sp_science_back_form_L6YLng", url: "?section=science-back-form", name: "science-back-form" },
//     { id: "shopify-section-template--25803843436917__sp_why_you_need_cfHGRQ", url: "?section=why-you-need", name: "why-you-need" },
//     { id: "shopify-section-template--25803843436917__sp_best_time_bbxNkr", url: "?section=best-time", name: "best-time" },
//     { id: "shopify-section-template--25803843436917__sp_collagen_nectar_LaadhW", url: "?section=collagen-nectar", name: "collagen-nectar" },
//     { id: "shopify-section-template--25803843436917__sp_girl_animation_i4inFm", url: "?section=girl-animation", name: "girl-animation" },
//     { id: "shopify-section-template--25803843436917__sp_product_block_9tbzjU", url: "?section=product-block-1", name: "product-block-1" },
//     { id: "shopify-section-template--25803843436917__sp_our_formulas_3xTNNr", url: "?section=our-formulas", name: "our-formulas" },
//     { id: "shopify-section-template--25803843436917__sp_wellness_Hb8F3m", url: "?section=wellness", name: "wellness" },
//     { id: "shopify-section-template--25803843436917__positive_reviews_LbPci7", url: "?section=positive-reviews", name: "positive-reviews" },
//     { id: "shopify-section-template--25803843436917__sp_backed_formula_NGCeEm", url: "?section=backed-formula", name: "backed-formula" },
//     { id: "shopify-section-template--25803843436917__sp_happy_customers_6NwM98", url: "?section=happy-customers", name: "happy-customers" },
//     { id: "shopify-section-template--25803843436917__sp_perla_mission_bLQ7XN", url: "?section=perla-mission", name: "perla-mission" },
//     { id: "shopify-section-template--25803843436917__sp_product_block_MiEq9X", url: "?section=product-block-2", name: "product-block-2" },
//     { id: "shopify-section-template--25803843436917__sp_faq_fjrEpV", url: "?section=faq", name: "faq" },
//     { id: "shopify-section-template--25803843436917__sp_scientific_references_iHwAn6", url: "?section=scientific-references", name: "scientific-references" },
//     { id: "shopify-section-template--25803843436917__sp_footer_wNTdqP", url: "?section=footer", name: "footer" }
//   ];

//   let currentSection = null;

//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const section = sections.find((s) => s.id === entry.target.id);
//           if (section && currentSection !== section.id) {
//             currentSection = section.id;
//             const newUrl = window.location.pathname + section.url.replace("?", "#");
//             const newTitle = `${baseTitle}_${section.name}`;
//             window.history.pushState({ path: newUrl }, "", newUrl);
//             document.title = newTitle;
//             window.dispatchEvent(new Event("locationchange"));
//             // console.log("Virtual URL changed:", newUrl);
//             // console.log("Title changed to:", newTitle);
//           }
//         }
//       });
//     },
//     { threshold: 0.1 }
//   );

//   sections.forEach((s) => {
//     const el = document.getElementById(s.id);
//     if (el) observer.observe(el);
//     else console.warn("Container not found:", s.id);
//   });

//   console.log("Virtual scroll tracking with title change initialized");
// });


//let lastUrl = window.location.pathname + window.location.search;

//window.addEventListener("hashchange", function () { 
//  setTimeout(() => {
//    history.replaceState(null, "", lastUrl); 
//  }, 0);
//});

document.addEventListener("DOMContentLoaded", () => {
  const elements = [
    document.querySelector('a.banner-try-now[href="#product-block"]'),
    document.querySelector('#stickyBtn.banner-try-now[href="#product-block"]')
  ];

  elements.forEach(el => {
    if (!el) return;

    el.addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.querySelector("#product-block");
      if (!target) return;

      target.scrollIntoView({ behavior: "smooth" });

      history.replaceState(null, "", window.location.pathname + window.location.search);
    });
  });
});

